import * as React from "react";
import Switch from "react-switch";
import { IntegrationItem } from "../../../types/StateTypes";
import { theme } from "../../../utils/theme";
import { PhoenixStyledTooltip } from "../../Dumb/PhoenixStyledTooltip";

interface ConnectSwitchProps {
  item: IntegrationItem;
  isConnected: boolean;
  disabled?: boolean;
  tooltipText?: string;
  onChange: (checked: boolean) => void;
}

const ConnectSwitch: React.FC<ConnectSwitchProps> = ({
  item,
  isConnected,
  disabled = false,
  tooltipText,
  onChange,
}) => {
  const tooltipId = `${item.name.toLowerCase()}-tooltip`;

  return (
    <>
      <PhoenixStyledTooltip id={tooltipId} />
      <div data-tip={tooltipText} data-for={tooltipId}>
        <Switch
          onChange={onChange}
          checked={isConnected}
          disabled={disabled}
          onColor={theme.PRIMARY500}
          offColor={theme.NEUTRAL200}
          height={16}
          width={32}
          handleDiameter={12}
          checkedIcon={false}
          uncheckedIcon={false}
        />
      </div>
    </>
  );
};

export { ConnectSwitch };
